import React from 'react';
import {observer, inject} from 'mobx-react';
import UserSelect from "../common_components/UserSelect";
import {injectIntl} from 'react-intl';

@injectIntl @inject('authorizationsStore') @observer
export default class AssigneeSelect extends React.Component{

    render(){
        const {feedbackChain, intl} = this.props;

        return (
            <div className={'toolbar'}>
                <div className={'title'}> <i className="fa fa-user-circle" />
                    &nbsp;{intl.formatMessage({id:"assignees_title"})}
                </div>
                <div className={'content'}>
                    <UserSelect
                        isAssigneeSelect={true}
                        users={feedbackChain.assignables}
                        value={feedbackChain.assignees}
                        onChange={this.handleChangeAssigneeSelect}
                        multi={true}
                        placeholder={intl.formatMessage({id: "assignees_placeholder"})}
                        disabled={!this.props.authorizationsStore.canEditFeedback(feedbackChain)}
                        style={{marginTop: '5px'}}
                    />
                </div>
            </div>
        );
    }

    handleChangeAssigneeSelect = (members) => {
        this.props.feedbackChain.updateAssignees(members);
    }
}
